import React, { useState } from 'react';
import {
    DataForPswResetSmsResponse,
    OnSubmitUserCheck,
    SetUsername,
    ResetPasswordErrorType
} from '@app/models';

import {
    ChangePasswordSuccess,
    ChangePassword,
    ResetPasswordValidate,
} from './';
import { useTypedTranslation } from '@app/hooks';
import { ResetPasswordSuggestionEmailCode } from './resetPasswordSuggestionEmailCode';
import { RESET_OPTION_EMAIL_NONE } from '@app/helpers';

interface IProps {
    setUsername: SetUsername;
    onSubmitUserCheck: () => OnSubmitUserCheck;
    availableResetOptions: string;
    isErrorValidateUsername: ResetPasswordErrorType;
    resetTokenObject: DataForPswResetSmsResponse | undefined;
}

export const ResetPasswordChooseComponent: React.SFC<IProps> = ({
    setUsername,
    onSubmitUserCheck,
    availableResetOptions,
    isErrorValidateUsername,
    resetTokenObject
}) => {
    const { translation } = useTypedTranslation();
    const [isPasswordChanged, setIsPasswordChanged] = useState<boolean>(false);
    const [userDataForChangePassword, setUserDataForChangePassword] = useState<DataForPswResetSmsResponse | null>(null);

    if (isPasswordChanged) {
        return <ChangePasswordSuccess />;
    } else if (userDataForChangePassword) {
        return <ChangePassword userDataForChangePassword={userDataForChangePassword} setIsPasswordChanged={setIsPasswordChanged} />;
    } else if (resetTokenObject) {
        if (resetTokenObject?.resetRequiresVerification) {
            return (
                <ResetPasswordSuggestionEmailCode
                    userDataForSubmitCode={resetTokenObject}
                    setUserDataForChangePassword={setUserDataForChangePassword}
                />
            );
        } else {
            return <ChangePassword userDataForChangePassword={resetTokenObject} setIsPasswordChanged={setIsPasswordChanged} />;
        }
    } else if (availableResetOptions === RESET_OPTION_EMAIL_NONE) {
        // none
        return <p className='forgot-password__cannot-reset'>{translation('CANNOT_RESET_PASSWORD')}</p>;
    } else if (isErrorValidateUsername) {
        return <ResetPasswordValidate onSubmit={onSubmitUserCheck} isError={isErrorValidateUsername} />;
    } else {
        return null;
    }
};
